// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator attendance`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import companies from 'modules/core/store/collections/companies'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import users from 'modules/core/store/collections/users'

import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import employees from 'modules/employees/store/collections/employees'
import locations from 'modules/locations/store/collections/locations'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  /* employees manually fetched by 1 pages in this module */
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 4 cases in this module */,
    [employeeGroups, {}] /* Referenced by 1 cases in this module */,
    [employees, {}] /* Referenced by 20 cases in this module */,
    [features, {}] /* Referenced by 56 cases in this module */,
    [legalEntities, {}] /* Referenced by 2 cases in this module */,
    [locations, {}] /* Referenced by 1 cases in this module */,
    [memberships, {}] /* Referenced by 1 cases in this module */,
    [teams, {}] /* Referenced by 1 cases in this module */,
    [users, {}] /* Referenced by 13 cases in this module */,
  ] /* Generated file 👉 artifacts/attendance-module-timeTracking.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
